import { useState, useEffect } from "react";
import { Box, CheckBox, Image, Text } from "grommet";
import { updateStateHandler, DrawArrayByRows } from "../Utils/Utils";
// import ConicalShouldered from '../../images/Bunch Shapes/ConicalShouldered.png';
import Cylindrical from '../../images/Bunch Shapes/Cylindrical.png';
// import LongConical from '../../images/Bunch Shapes/LongConical.png';
import ShortOnical from '../../images/Bunch Shapes/ShortOnical.png';
// import WingedCylindrical from '../../images/Bunch Shapes/WingedCylindrical.png';
import WingedDouble from '../../images/Bunch Shapes/WingedDouble.png';

const BunchShapeChoice = (props) => {
    const choices = 
    [
        // {
        //     label: "Conical Shouldered",
        //     value: "ConicalShouldered",
        //     stateKey: 'BunchShapeCS',
        //     imageURL: ConicalShouldered,
        //     checked: props.preHarvestValues.BunchShapeCS
        // },
        {
            label: "Cylindrical",
            value: "Cylindrical",
            stateKey:'BunchShapeC',
            imageURL: Cylindrical,
            checked: props.preHarvestValues.BunchShapeC
        },
        // {
        //     label: "Long Conical",
        //     value: "LongConical",
        //     stateKey: 'BunchShapeLC',
        //     imageURL: LongConical,
        //     checked: props.preHarvestValues.BunchShapeLC
        // },
        {
            label: "Conical",
            value: "ShortConical",
            stateKey: 'BunchShapeSC',
            imageURL: ShortOnical,
            checked: props.preHarvestValues.BunchShapeSC
        },
        // {
        //     label: "Winged Cylindrical",
        //     value: "WingedCylindrical",
        //     stateKey: 'BunchShapeWC',
        //     imageURL: WingedCylindrical,
        //     checked: props.preHarvestValues.BunchShapeWC
        // },
        {
            label: "Winged Double",
            value: "WingedDouble",
            stateKey: 'BunchShapeWD',
            imageURL: WingedDouble,
            checked: props.preHarvestValues.BunchShapeWD
        }
    ];

    const [checked, setChecked] = useState([]);

    // Add/Remove checked item from list
    const handleCheck = (event, item) => {
        updateStateHandler(props.stateHandler, item.stateKey, event.target.checked );

        setPrevValue(checked.length);
 
        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };

    useEffect(() => {
        const newValue = checked.length;
        // console.log("newValue >> ", newValue);
        if(props.updateProgressByCheck){
            props.updateProgressByCheck(prevValue, newValue);
        }
    },[checked])
    
    const [prevValue, setPrevValue] = useState(0);

    useEffect(() => {
        // initialization previous value at page opening
        var updatedList = [...checked];      
        choices.map(option => {
            if(option.checked === true){
                updatedList = [...checked, option.value];
            }            
        })

        setChecked(updatedList);

        setPrevValue(updatedList.length);
        // console.log("prevValue >> ", updatedList.length);
    }, []);  

    const DrawItem = (item) =>
    {
        //console.log("item >> ",item);      
        return(
            <Box height="small" width="small" key={item.stateKey} pad="small" margin={{vertical: "xxsmall"}} align="start" justify="center" fill>          
                <Image // fit="contain" 
                    src={item.imageURL}></Image>
                <Box direction="row"  pad={{vertical: "5px"}} alignContent="start" align="start" width="120px" height="15px" style={{margin: "0 auto"}}>
                    <CheckBox  value={item.value} 
                        disabled={props.disable} 
                        checked={item.checked ? item.checked : false} 
                        onChange={ event => handleCheck(event, item)}
                        pad={{horizontal: "5px"}}
                    >
                    </CheckBox>  
                    <Text alignSelf="start" size="small">
                    {item.label}
                    </Text>                   
                </Box>        
            </Box> 
        );
    };


    return (
        <Box direction="column" pad="xxsmall" align="center"
            gap="small"
            fill="horizontal"
        >
            <Box alignSelf="start" pad={{horizontal: "small"}}>
                <Text alignSelf="start" color="brand" size="18px">
                    Bunch Shape:
                </Text>
            </Box>
            {DrawArrayByRows(choices, props.numOfColumns, 'Bunch', DrawItem)}
        </Box>
    );
};

export default BunchShapeChoice;
